import { render } from "./settingPage.vue?vue&type=template&id=e9b75dac"
import script from "./settingPage.vue?vue&type=script&lang=js"
export * from "./settingPage.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/mcd-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__